import {ModuleWithProviders, NgModule} from '@angular/core';
import {LocalStorageService} from './service/local-storage.service';
import {UserPreferencesService} from './service/user-preferences.service';
import {BaseComponent} from './components/base.component';
import {BuildingService} from './service/building-service';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MDBBootstrapModulesPro} from 'ng-uikit-pro-standard';
import {LoggerService} from './service/logger.service';
import {LocalizationService} from './service/localization.service';
import {AuthorizationService} from './service/authorization.service';
import {TitleComponent} from './components/title/title.component';
import {ErrorAlertComponent} from './components/error-alert/error-alert.component';
import {AngularSvgIconModule} from 'angular-svg-icon';
import {TitleDirective} from './directives/title.directive';
import {BgDirective} from './directives/bg.directive';
import {TextColorDirective} from './directives/text-color.directive';
import {SVGColorDirective} from './directives/svg-color.directive';
import {TokenService} from './service/token.service';
import {RefreshTokenService} from './service/refresh-token.service';
import {ImgThumbnailComponent} from './components/img-thumbnail/img-thumbnail.component';
import {SmallIconThumbnailComponent} from './components/small-icon-thumbnail/small-icon-thumbnail.component';
import {BigIconThumbnailComponent} from './components/big-icon-thumbnail/big-icon-thumbnail.component';
import {SmallImgThumbnailComponent} from './components/small-img-thumbnail/small-img-thumbnail.component';
import {ErrorLogService} from './service/error-log.service';
import {CardSpinnerComponent} from './components/card-spinner/card-spinner.component';
import { Accountservice } from './service/account-service';
import { ChangeCultureConfirmationModalComponent } from './components/change-culture-confirmation-modal/change-culture-confirmation-modal.component';
import {ChappsCommonAngularLibraryModule} from '@npm.chapps.com/chapps.common.angular.library';
import {HttpHeadersService} from './service/http-headers.service';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {AuthInterceptor} from '../../http/auth.interceptor';
import { TranslateEnumPipe } from './enum-translate-pipe';
import { TimezoneInterceptor } from 'src/app/http/timezone.interceptor';
import { UpdateModalComponent } from './components/update-modal/update-modal.component';
import { OfflinePageComponent } from './components/offline-page/offline-page.component';
import { OfflineService } from './service/offline.service';
import { ManifestService } from './service/manifest.service';
import { UpdateService } from './service/update.service';
import { IconColorDirective } from './directives/icon.directive';
import { MatDialogModule } from '@angular/material/dialog';
import { StructureService } from './service/structure-service';
import { ConfirmationDialogComponent } from './dialogs/confirmation-dialog/confirmation-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    MDBBootstrapModulesPro,
    AngularSvgIconModule,
    ChappsCommonAngularLibraryModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatSnackBarModule
  ],
  declarations: [
    BaseComponent,
    TitleComponent,
    ErrorAlertComponent,
    TitleDirective,
    BgDirective,
    TextColorDirective,
    SVGColorDirective,
    ImgThumbnailComponent,
    SmallImgThumbnailComponent,
    SmallIconThumbnailComponent,
    BigIconThumbnailComponent,
    CardSpinnerComponent,
    ChangeCultureConfirmationModalComponent,
    TranslateEnumPipe,
    UpdateModalComponent,
    OfflinePageComponent,
    IconColorDirective,
    ConfirmationDialogComponent,
  ],
  exports: [
    BaseComponent,
    TitleComponent,
    ErrorAlertComponent,
    TitleDirective,
    BgDirective,
    TextColorDirective,
    SVGColorDirective,
    ImgThumbnailComponent,
    SmallImgThumbnailComponent,
    SmallIconThumbnailComponent,
    BigIconThumbnailComponent,
    CardSpinnerComponent,
    ChangeCultureConfirmationModalComponent,
    TranslateEnumPipe,
    IconColorDirective,
    ConfirmationDialogComponent,
    MatButtonModule,
    MatSnackBarModule
  ]
})
export class SharedModule {

  static forChild(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        {
          provide: HTTP_INTERCEPTORS,
          useClass: TimezoneInterceptor,
          multi: true
        },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
      ]
    };
  }

  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        LocalizationService,
        AuthorizationService,
        LoggerService,
        LocalStorageService,
        UserPreferencesService,
        BuildingService,
        TokenService,
        RefreshTokenService,
        ErrorLogService,
        Accountservice,
        HttpHeadersService,
        StructureService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: TimezoneInterceptor,
          multi: true
        },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        OfflineService,
        ManifestService,
        UpdateService
      ]
    };
  }
}
